import React, { useEffect } from 'react';
import styles from './PersonalInformation.module.scss';
import emailIcon from '../../../assets/Imagess/ProfileEmailIcon.svg';
import phoneIcon from '../../../assets/Imagess/ProfilePhoneIcon.svg';
import userIcon from '../../../assets/Imagess/ProfileUserIcon.svg';
import TextInput from '../../Atoms/Inputs/TextInput';

function Profile({
  info,
  firstName,
  lastName,
  email,
  mobile,
  setFirstName,
  setLastName,
  setEmail,
  setMobile,
  disabledInputs,
}) {
  useEffect(() => {}, []);

  //------------------------------------------------------

  return (
    <>
      <div className={`${styles['parentContainer']}`}>
        <TextInput
          icon={userIcon}
          width='100%'
          label='الاسم الأول'
          name='firstName'
          value={firstName}
          placeholder={'أدخل الاسم الأول'}
          onChange={(e, value) => {
            setFirstName(value);
          }}
          disabledInputOnly={disabledInputs}
          required
          onlyValue
        />
        <TextInput
          icon={userIcon}
          width='100%'
          label='الاسم الأخير'
          name='lastName'
          value={lastName}
          placeholder={'أدخل الاسم الأخير'}
          onChange={(e, value) => {
            setLastName(value);
          }}
          disabledInputOnly={disabledInputs}
          required
          onlyValue
        />
        <TextInput
          icon={emailIcon}
          width='100%'
          label='البريد الإلكتروني'
          name='email'
          type={'email'}
          value={email}
          placeholder={'أدخل البريد الإلكتروني'}
          onChange={(e, value) => {
            setEmail(value);
          }}
          disabledInputOnly={disabledInputs}
          required
          onlyValue
        />
        <TextInput
          icon={phoneIcon}
          width='100%'
          label='الهاتف المحمول'
          name='mobile'
          value={mobile}
          placeholder={'أدخل رقم الهاتف المحمول'}
          onChange={(e, value) => {
            setMobile(value);
          }}
          disabledInputOnly={disabledInputs}
          onlyValue
        />
      </div>
    </>
  );
}

export default Profile;
